<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonEditMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'edit'">
            <div class="card">
                <div class="card-body">
                    <em-entity-edit-form ref="emEntityEditForm" :entity="modelName"></em-entity-edit-form>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    // Author Lin
    // Date 2021-05-16 19:04:44

    import emCommonEditMixin from "@/mixin/em/common/edit";

    export default {
        name: "sithMesInventoryAbnormalArrivalProcessEditView",
        mixins: [emCommonEditMixin],
        computed:{
            modelName(){
                return this.$_emRouterHelperMixin_entityName
            }
        },
        // methods: {
        //     initForm() {
        //         if(this.$route.query.hasOwnProperty('materialId')) {
        //             var poItemId = this.$route.query.materialId;
        //             console.log(poItemId)
        //             this.$store.commit(this.modelName + "/setEntityAttribute", {key: "poItemId", newValue: poItemId})
        //         }   
        //     }
        // },
        // mounted() {
        //     this.initForm();
        // }
    };
</script>